import serialize from 'form-serialize'

// GET リクエスト用
// <form> タグのフォームデータを集約して Object に変換をする
// axios などの Ajax でフォームリクエストをする際に利用をする
export const convertFormDataForGet = (event) => {
  return serialize(event.target, { hash: true })
}

// POST リクエスト用
export const convertFormDataForPost = (event) => {
  return serialize(event.target)
}

// ページトップへスクロール移動
// Ajax でのエラー時に利用する
export const pageToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

// ページトップへスクロール移動
// Entry form専用
export const pageBackToTop = () => {
  window.scrollTo({
    top: 0
  })
}
